import { TDispatch } from '../type';
import { TMenuState } from './menu.type';

export const menuReducer = (state: TMenuState, { type, payload }: TDispatch): TMenuState => {
  switch (type) {
    case 'set_active_path':
      return { ...state, activePath: payload as string };
    case 'set_menu_mobile_open':
      return { ...state, isMenuMobileOpen: true };
    case 'set_menu_mobile_close':
      return { ...state, isMenuMobileOpen: false };
    case 'menu_set_is_show_modal_view_freight_page':
      return { ...state, isShowModalViewFreightPage: payload as boolean };
    default:
      return state;
  }
};

menuReducer.key = 'menu';
menuReducer.initialState = {
  isMenuMobileOpen: false,
  activePath: null,
  isShowModalViewFreightPage: false,
};

export default { menuReducer };
